import Utils from '../../modules/utils'

const getVpoStage = (vpoId, callbackFunc) => {
  const url = 'vpo_stages/' + vpoId
  Utils.get(url, callbackFunc)
}

export {getVpoStage}
